import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Shield } from 'lucide-react'

export default function AdminSecuritySettings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">ความปลอดภัย</h1>
        <p className="text-muted-foreground">การตั้งค่าความปลอดภัยและการเข้าถึง</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5" />
            การตั้งค่าความปลอดภัย
          </CardTitle>
          <CardDescription>ส่วนนี้อยู่ระหว่างการพัฒนา</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            ระบบความปลอดภัยกำลังอยู่ระหว่างการพัฒนา<br />
            จะสามารถจัดการสิทธิ์การเข้าถึง, ตั้งค่า 2FA และดู audit logs ได้ในอนาคต
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
